import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import P from '@deliveroo/consumer-component-library/components/P';
import Heading from '@deliveroo/consumer-component-library/components/Heading';

import Header from '../../containers/Header';
import LandingPageBreadcrumbs from '../LandingPageBreadcrumbs';
import styles from './styles.scss';

export default function CuisinePageHero({
  image,
  heading,
  description,
  locationSearch,
  breadcrumbs,
  header,
}) {
  return (
    <Fragment>
      <PageContainer fullWidth="always">
        <div className={styles.navHeader}>
          {header || <Header isTransparent logoColor="white" />}
        </div>
        <div className={styles.outerWrapper}>
          <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />
          <div className={styles.content}>
            <div className={styles.description}>
              <LandingPageBreadcrumbs links={breadcrumbs} />
              <Heading level={1} size="medium" color="white" adjacentVerticalSpacing="medium">
                {heading}
              </Heading>
              <P color="white" adjacentVerticalSpacing="medium">
                {description}
              </P>
            </div>
          </div>
        </div>
      </PageContainer>
      {locationSearch && (
        <PageContainer fullWidth="always">
          <div className={styles.locationSearchWrapper}>
            <PageContainer>
              <div className={styles.locationSearch}>{locationSearch}</div>
            </PageContainer>
          </div>
        </PageContainer>
      )}
    </Fragment>
  );
}

CuisinePageHero.propTypes = {
  image: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  locationSearch: PropTypes.node.isRequired,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  header: PropTypes.node,
};

CuisinePageHero.defaultProps = {
  header: undefined,
};
